/**
 * ACT004 打卡成功后跳转 · 条件目标页（与控制台 act004-checkin-success-jump.js 口径一致）
 */
import { normalizeConditionalTargetCheckinIndexes } from '@/utils/act004-user-form-fields'

export const ACT004_CHECKIN_SUCCESS_JUMP_CONDITION_TYPES = [
  { value: 'CHECKIN_COUNT', label: '累计打卡次数' },
  { value: 'CHECKIN_POINTS', label: '打卡点位' }
]

export function normalizeCheckInSuccessConditionType(type) {
  const t = String(type || '').trim().toUpperCase()
  return t === 'CHECKIN_POINTS' ? 'CHECKIN_POINTS' : 'CHECKIN_COUNT'
}

export function normalizeCheckInSuccessMinCount(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) && n > 0 ? n : 0
}

export function normalizeCheckInSuccessConditionalRule(rule) {
  if (!rule || typeof rule !== 'object') return null
  const targetPageIndex = parseInt(rule.targetPageIndex, 10)
  if (!Number.isFinite(targetPageIndex) || targetPageIndex < 0) return null
  const conditionType = normalizeCheckInSuccessConditionType(rule.conditionType)
  const minCheckinCount = normalizeCheckInSuccessMinCount(rule.minCheckinCount)
  const checkinIndexes = normalizeConditionalTargetCheckinIndexes(rule.checkinIndexes)
  if (conditionType === 'CHECKIN_COUNT' && minCheckinCount <= 0) return null
  if (conditionType === 'CHECKIN_POINTS' && !checkinIndexes.length) return null
  return {
    conditionType,
    minCheckinCount: conditionType === 'CHECKIN_COUNT' ? minCheckinCount : 0,
    checkinIndexes: conditionType === 'CHECKIN_POINTS' ? checkinIndexes : [],
    targetPageIndex
  }
}

export function normalizeCheckInSuccessConditionalRules(source) {
  if (Array.isArray(source)) {
    return source.map((r) => normalizeCheckInSuccessConditionalRule(r)).filter(Boolean)
  }
  return []
}

export function evaluateCheckInSuccessJumpTarget(options) {
  const opts = options && typeof options === 'object' ? options : {}
  const type = normalizeCheckInSuccessConditionType(opts.conditionType)
  if (type === 'CHECKIN_POINTS') {
    const indexes = normalizeConditionalTargetCheckinIndexes(opts.checkinIndexes)
    if (!indexes.length || typeof opts.isCheckinPointDone !== 'function') {
      return false
    }
    return indexes.every((idx) => !!opts.isCheckinPointDone(idx))
  }
  const min = normalizeCheckInSuccessMinCount(opts.minCheckinCount)
  if (min <= 0) return false
  const getCount = typeof opts.getCheckinCount === 'function' ? opts.getCheckinCount : () => 0
  const count = parseInt(getCount(), 10)
  return Number.isFinite(count) && count >= min
}

export function resolveCheckInSuccessTargetPageIndex(rulesSource, evaluateOptions, defaultPageIndex) {
  const fallbackRaw = parseInt(defaultPageIndex, 10)
  const fallback =
    Number.isFinite(fallbackRaw) && fallbackRaw >= 0 ? fallbackRaw : null
  const rules = normalizeCheckInSuccessConditionalRules(
    rulesSource && rulesSource.checkInSuccessConditionalRules != null
      ? rulesSource.checkInSuccessConditionalRules
      : rulesSource
  )
  const opts = evaluateOptions && typeof evaluateOptions === 'object' ? evaluateOptions : {}
  for (let i = 0; i < rules.length; i++) {
    const r = rules[i]
    if (
      evaluateCheckInSuccessJumpTarget({
        conditionType: r.conditionType,
        minCheckinCount: r.minCheckinCount,
        checkinIndexes: r.checkinIndexes,
        getCheckinCount: opts.getCheckinCount,
        isCheckinPointDone: opts.isCheckinPointDone
      })
    ) {
      return r.targetPageIndex
    }
  }
  // 条件均未命中：走默认「目标页面」（未配置则为 null，不跳转）
  return fallback
}
